import { useQuery } from "@tanstack/react-query";
import { publicAxios } from "../axios";

const getAddresses = async (address: string) => {
	const { data } = await publicAxios.get(`/address/search/${address}`);
	return data;
};

export const useGetAddresses = (address: string) => {
	return useQuery({
		queryKey: ["address", address],
		queryFn: async () => getAddresses(address),
		enabled: !!address,
		retry: false,
	});
};
